'use client';

import { Suspense } from 'react';
import { useSearchParams } from 'next/navigation';
import { AppNav } from '@/components/AppNav';
import { HedgeLabTable } from '@/components/research/HedgeLabTable';

// Wrapping useSearchParams in Suspense per Next.js 15+ requirement — when
// rendered outside a Suspense boundary it forces the entire route to be
// dynamic, which is fine here, but Next still warns. Suspense boundary
// keeps the warning quiet without changing behavior.
function HedgeLabBody({ focused }: { focused: boolean }) {
  const params = useSearchParams();
  const symbol = params.get('symbol');
  const open = params.get('open');
  return (
    <>
      {!focused && (
        <div className="sticky top-[36px] z-40 bg-[#0a0e14] -mx-4 px-4 pt-1 pb-2 mb-3 border-b border-[#1e293b] shadow-[0_4px_8px_-4px_rgba(0,0,0,0.4)]">
          <h1 className="text-xl font-semibold mb-0.5">Hedge Lab</h1>
          <p className="text-[11px] text-[#94a3b8] leading-snug max-w-4xl">
            Position management — RSI/momentum + six ranked strategies (Trim, Covered Call, Collar, CSP, Stock Replacement, Hold) priced from live BBG SAPI options. Click <strong className="text-white">Hedge</strong> on a name for the focused view.
          </p>
        </div>
      )}
      <HedgeLabTable initialSymbol={symbol} initialStrategy={open} />
    </>
  );
}

function HedgeLabBodyWrapper() {
  const params = useSearchParams();
  const focused = !!params.get('symbol');
  return <HedgeLabBody focused={focused} />;
}

export default function HedgeLabPage() {
  return (
    <div className="min-h-screen text-[#e2e8f0] pb-12">
      <AppNav />
      <div className="max-w-6xl mx-auto px-4 pt-2">
        <Suspense fallback={<div className="text-[12px] text-[#64748b]">Loading…</div>}>
          <HedgeLabBodyWrapper />
        </Suspense>
      </div>
    </div>
  );
}
